module.exports = __webpack_public_path__ + "arrow.svg?dfa259b4c9d006b475d61fd27a8a6e20";


//////////////////
// WEBPACK FOOTER
// ./client/assets/icones_app/arrow.svg
// module id = 1135
// module chunks = 0